import { SanitizeHTMLString } from "@circle-react-shared/uikit/SanitizeContent";
import { Button } from "@circleco/compass/components/Button";
import { Typography } from "@circleco/compass/components/Typography";
import type { MouseEvent } from "react";

interface DiscoverEmptyStateProps {
  description: string;
  header: string;
  onSecondaryClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  secondaryLabel?: string;
}

export const DiscoverEmptyState = ({
  header,
  description,
  secondaryLabel,
  onSecondaryClick,
}: DiscoverEmptyStateProps) => (
  <div
    className="flex size-full flex-col items-center justify-center gap-9 p-8 text-center"
    data-testid="empty-state"
  >
    <div className="flex max-w-lg flex-col gap-3">
      <Typography variant="heading-lg">{header}</Typography>
      <Typography variant="body-md" color="secondary">
        <SanitizeHTMLString content={description} />
      </Typography>
    </div>
    {secondaryLabel && onSecondaryClick && (
      <Button variant="secondary" onClick={onSecondaryClick}>
        {secondaryLabel}
      </Button>
    )}
  </div>
);
